// src/store/index.js
import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import uiReducer from './slices/uiSlice';
import productReducer from './slices/productSlice';
import cartReducer from './slices/cartSlice';
import checkoutReducer from './slices/checkoutSlice';
import paymentReducer from './slices/paymentSlice';
import orderReducer from './slices/orderSlice';
import wishlistReducer from './slices/wishlistSlice';
import maintenanceReducer from './slices/maintenanceSlice'

const store = configureStore({
  reducer: {
    auth: authReducer,
    ui: uiReducer,
    products: productReducer,
    cart: cartReducer,
    checkout: checkoutReducer,
    payment: paymentReducer,
    orders: orderReducer,
    wishlist: wishlistReducer,
    maintenance: maintenanceReducer
  }
});

export default store;